import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";
import { Helmet } from "react-helmet";

export default function Transporting_heavy_equipment() {

  const seo = {
    title:
      "הובלת ציוד כבד | הובלת מכונות וציוד תעשייתי | ש.מ הובלות ומנופים",

    description:
      "שירותי הובלת ציוד כבד לקבלנים, חברות, מפעלים, עסקים ולקוחות פרטיים. הובלת מכונות, מתקנים, ציוד תעשייתי ומטענים גדולים, עם אפשרות לשילוב מנוף בהתאם לתנאי השטח.",

    url:
      "https://smtovala.co.il/Transporting_heavy_equipment",

    image:
      "https://smtovala.co.il/images/32.jpeg"
  };

  return (
    <>
      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      <div className="Transportation_of_building_materials-page">

        <div className="Transportation_of_building_materials-hero">

          <div className="Transportation_of_building_materials-overlay">

            <h1>הובלת ציוד כבד</h1>

          </div>

        </div>


        {/* =====================================================
            CONTENT
        ===================================================== */}

        <div className="page3">

          <div className="container">


            {/* =====================================================
                VIDEO - ראשון
            ===================================================== */}

            <div className="building-video-box">

              <div className="building-video-title">
                הובלת ציוד כבד
              </div>




        

            </div>


            {/* =====================================================
                TOP TEXT
            ===================================================== */}

            <h2 className="top-text">

              הובלת ציוד כבד דורשת תכנון מקצועי, ציוד מתאים וניסיון
              בהתמודדות עם מטענים גדולים ובמשקלים שונים. ש.מ הובלות
              ומנופים מספקת שירותי הובלת ציוד כבד לקבלנים, חברות,
              מפעלים, עסקים ולקוחות פרטיים, תוך התאמת פתרון ההובלה
              לסוג הציוד, למשקל ולתנאי השטח.

            </h2>


            {/* =====================================================
                IMAGE + TEXT
            ===================================================== */}

            <div className="content-row">

              <div className="image-box">

                <img
                  src="/images/32.jpeg"
                  alt="הובלת ציוד כבד"
                />

              </div>


              <div className="text-box">

                <p>

                  הובלת ציוד כבד מתחילה בהבנה של מאפייני המטען.
                  יש לקחת בחשבון את משקל הציוד, המידות, אופן ההעמסה,
                  תנאי הדרך והגישה לנקודת האיסוף והפריקה. תכנון מוקדם
                  מאפשר להתאים את אמצעי ההובלה ולבצע את העבודה בצורה
                  מסודרת בהתאם לתנאי השטח.

                </p>


                <p>

                  ש.מ הובלות ומנופים מספקת פתרונות להובלת מגוון רחב
                  של ציוד כבד, לרבות מכונות, ציוד תעשייתי, מתקנים,
                  כלי עבודה, ציוד לאתרי בנייה, חלקי מכונות ומטענים
                  גדולים נוספים, בהתאם לצורכי הלקוח ולמאפייני ההובלה.

                </p>

              </div>

            </div>


            {/* =====================================================
                SECTION 1
            ===================================================== */}

            <h2 className="main-title">
              הובלת ציוד כבד – תכנון מקצועי לפני תחילת העבודה
            </h2>


            <div className="bottom-text">

              <p>

                לפני כל הובלת ציוד כבד חשוב לאסוף את כל פרטי העבודה:
                סוג הציוד, המשקל, המידות, נקודת האיסוף, נקודת הפריקה
                והדרך שבה ניתן להעמיס ולהעביר את המטען.

              </p>


              <p>

                בנוסף, חשוב לבדוק מראש את תנאי הגישה. רחובות צרים,
                שערים, חניות, כניסות למפעלים, אתרי בנייה או שטחים
                מוגבלים יכולים להשפיע על אופן ביצוע ההובלה ועל בחירת
                אמצעי ההובלה המתאים.

              </p>


              {/* =====================================================
                  SECTION 2
              ===================================================== */}

              <h2 className="main-title">
                הובלת ציוד כבד באמצעות משאית
              </h2>


              <p>

                משאית המתאימה למטען מאפשרת להעביר ציוד כבד ממקום
                למקום בצורה מסודרת. בחירת המשאית נעשית בהתאם למשקל
                הציוד, למידותיו, לכמות המטען ולתנאי הגישה בדרך וביעד.

              </p>


              <p>

                כאשר נדרשת גם העמסה או פריקה באמצעות מנוף, ניתן לשלב
                בין שירותי הובלה לבין עבודת מנוף, בהתאם לסוג המטען,
                למיקום ולתנאים הקיימים באתר.

              </p>


              {/* =====================================================
                  SECTION 3
              ===================================================== */}

              <h2 className="main-title">
                הובלת ציוד כבד לאתרי בנייה ומפעלים
              </h2>


              <p>

                באתרי בנייה, מפעלים, מחסנים ועסקים קיימת לעיתים
                דרישה להעברת מכונות, מתקנים וציוד כבד. הובלה נכונה
                מאפשרת להעביר את הציוד אל היעד בהתאם לתכנון הפרויקט
                ולשלב העבודה.

              </p>


              <p>

                ש.מ הובלות ומנופים מספקת שירותי הובלת ציוד כבד
                לאתרי בנייה, מפעלים, עסקים וללקוחות פרטיים, בהתאם
                לסוג הציוד, לדרישות ההובלה ולתנאי השטח.

              </p>


              {/* =====================================================
                  SECTION 4
              ===================================================== */}

              <h2 className="main-title">
                הובלת ציוד כבד עם מנוף
              </h2>


              <p>

                כאשר לא ניתן לבצע פריקה ישירות לצד המשאית, עבודת
                מנוף יכולה לאפשר הרמה והעברה של הציוד אל נקודת
                הפריקה המתאימה, בהתאם לאפשרויות העבודה במקום.

              </p>


              <p>

                שילוב של משאית ומנוף מתאים במקרים שבהם יש צורך
                להרים מכונות, מתקנים, ציוד תעשייתי או מטענים כבדים
                אל אזורים שבהם לא ניתן לבצע פריקה רגילה.

              </p>


              {/* =====================================================
                  SECTION 5
              ===================================================== */}

              <h2 className="main-title">
                הובלת מכונות, מתקנים וציוד תעשייתי
              </h2>


              <p>

                מכונות וציוד תעשייתי יכולים להגיע במגוון רחב של
                גדלים, משקלים וצורות. לכן כל הובלה דורשת התייחסות
                למאפייני המטען ולאופן שבו ניתן להעמיס, להוביל
                ולפרוק אותו.

              </p>


              <p>

                ש.מ הובלות ומנופים מתאימה את פתרון ההובלה לסוג
                הציוד, למשקל, למידות ולתנאי הגישה, במטרה לספק
                מענה מתאים לצורכי העבודה.

              </p>


              {/* =====================================================
                  SECTION 6
              ===================================================== */}

              <h2 className="main-title">
                למה חשוב לבחור חברה מקצועית להובלת ציוד כבד?
              </h2>


              <p>

                ציוד כבד אינו דומה להובלה רגילה. יש צורך להבין את
                מאפייני המטען, לתכנן את דרך ההובלה ולבחון מראש את
                תנאי הגישה והפריקה.

              </p>


              <p>

                תכנון נכון מסייע להתאים את אמצעי ההובלה לעבודה
                ולצמצם הפתעות במהלך הביצוע. ש.מ הובלות ומנופים
                מתאימה את פתרון ההובלה לסוג הציוד, למשקל המטען,
                למידותיו ולדרישות הפרויקט.

              </p>


              {/* =====================================================
                  SECTION 7
              ===================================================== */}

              <h2 className="main-title">
                ש.מ הובלות ומנופים – הובלת ציוד כבד בפריסה ארצית
              </h2>


              <p>

                ש.מ הובלות ומנופים מספקת שירותי הובלת ציוד כבד,
                מכונות, מתקנים וציוד תעשייתי עבור קבלנים, חברות,
                מפעלים, עסקים ולקוחות פרטיים. השירות מותאם לסוג
                המטען ולתנאים הקיימים בנקודת האיסוף והפריקה.

              </p>


              <p>

                צריכים להוביל ציוד כבד? צרו איתנו קשר, ספרו לנו
                מה אתם צריכים להעביר ומהם תנאי ההובלה, ונבחן
                עבורכם את פתרון ההובלה המתאים.

              </p>

            </div>


            {/* =====================================================
                CONTACT
            ===================================================== */}

            <ContactSection2 />


            {/* =====================================================
                LINKS
            ===================================================== */}

            <div className="links">

              <Link
                to="/Transporting_wood"
                className="link-right"
              >
                הובלת עצים
              </Link>


              <Link
                to="/Container_Transportation"
                className="link-left"
              >
                הובלת מכולות
              </Link>

            </div>


          </div>

        </div>

      </div>
    </>
  );
}
